import script from "./Helper.vue?vue&type=script&setup=true&lang=js"
export * from "./Helper.vue?vue&type=script&setup=true&lang=js"

import "./Helper.vue?vue&type=style&index=0&id=3e75a760&scoped=true&lang=less"

import exportComponent from "/data/web/pay/brpay/brpay-h5/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3e75a760"]])

export default __exports__